import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/list-duck";
import { IProductLine } from "interfaces/product-line";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "LIST_PRODUCT_LINE_" }
);

export interface ListProductLineState extends IState {
  data: IProductLine[];
}

interface ISuccessListProductLineAction extends ISuccessAction {
  data: IProductLine[];
}

const INITIAL_STATE: ListProductLineState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListProductLineState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: ListProductLineState, action: ISuccessListProductLineAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListProductLineState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listProductLines = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListProductLineTypes = Types;
export const ListProductLineActions = Creators;
